<script>
	import { logoDone } from '../js/model/stores';
	import Subline from ".././components/Subline.svelte";

	logoDone.set(true);
</script>
<style>

	div {
		position: relative;
		top: 41%;
		margin: 0 auto;
		width: fit-content;
		transform: translateY(-60%);
	}

	@media (min-width: 640px) {
		div {
			top: 32%;
		}
	}
</style>

<svelte:head>
<title>Chemnitz 2025</title>
</svelte:head>

<div>
	<svg width="318" height="318" viewBox="0 0 318 318" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M294.597 215.132L211.02 215.132L185.914 215.132C173.214 215.132 162.562 225.38 162.562 238.496C162.562 251.203 172.804 261.86 185.914 261.86L211.02 261.86L294.597 261.86C307.297 261.86 317.949 251.613 317.949 238.496C317.949 225.38 307.297 215.132 294.597 215.132Z" fill="#F6F4DB"/>
	<path d="M294.597 174.419L211.02 174.419L185.914 174.419C173.214 174.419 162.562 184.667 162.562 197.783C162.562 210.49 172.804 221.147 185.914 221.147L211.02 221.147L294.597 221.147C307.297 221.147 317.949 210.9 317.949 197.783C317.949 184.667 307.297 174.419 294.597 174.419Z" fill="#F6F4DB"/>
	<path d="M294.597 133.706L211.02 133.706L185.914 133.706C173.214 133.706 162.562 143.953 162.562 157.07C162.562 169.776 172.804 180.434 185.914 180.434L211.02 180.434L294.597 180.434C307.297 180.434 317.949 170.186 317.949 157.07C317.949 143.953 307.297 133.706 294.597 133.706Z" fill="#F6F4DB"/>
	<path d="M294.597 92.9927L211.02 92.9927L185.914 92.9927C173.214 92.9927 162.562 103.24 162.562 116.356C162.562 129.063 172.804 139.72 185.914 139.72L211.02 139.72L294.597 139.72C307.297 139.72 317.949 129.473 317.949 116.356C317.949 103.24 307.297 92.9927 294.597 92.9927Z" fill="#F6F4DB"/>
	<path d="M162.562 105.519L162.562 189.096L162.562 238.259C162.562 250.96 172.809 261.612 185.925 261.612C198.632 261.612 209.289 251.37 209.289 238.259L209.289 189.096L209.289 105.519C209.289 92.819 199.042 82.167 185.925 82.167C172.809 82.167 162.562 92.819 162.562 105.519Z" fill="#F6F4DB"/>
	<path d="M162.562 23.725L162.562 107.302L162.562 156.465C162.562 169.165 172.809 179.817 185.925 179.817C198.632 179.817 209.289 169.575 209.289 156.465L209.289 107.302L209.289 23.725C209.289 11.0245 199.042 0.372542 185.925 0.372542C172.809 0.372543 162.562 11.0245 162.562 23.725Z" fill="#F6F4DB"/>
	<path d="M197.993 275.248L156.152 119.096L-0.000157119 160.937L41.8406 317.089L197.993 275.248Z" fill="#5A97C3"/>
</svg>
</div>
<Subline text="<strong>Super.</strong><br/>Das hat geklappt!"/>
